import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { DownloadButton } from "@/components/shared/DownloadButton";

export const FloatingCTA = () => {
  const { t } = useTranslation();

  return (
    <motion.div
      initial={{ y: 100, opacity: 0, x: "-50%" }}
      animate={{ y: 0, opacity: 1, x: "-50%" }}
      transition={{ delay: 1, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      className="fixed bottom-4 left-1/2 z-40 sm:hidden w-[92%]"
    >
      <DownloadButton
        testId="floating-mobile-cta"
        className="flex items-center justify-between w-full bg-slate900/95 backdrop-blur-xl border border-white/10 text-white rounded-2xl px-4 py-3.5 shadow-2xl"
      >
        <span className="flex items-center gap-2 text-sm font-semibold">
          <span className="relative flex h-2.5 w-2.5">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-coral opacity-75" />
            <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-coral" />
          </span>
          {t("floating_cta.text")}
        </span>
        <span className="flex items-center gap-1 bg-coral text-white text-xs font-bold px-3 py-1.5 rounded-full">
          {t("floating_cta.cta")} <ArrowUpRight size={13} />
        </span>
      </DownloadButton>
    </motion.div>
  );
};
